import { WorkflowStageDetail } from 'api-clients/monolith';
import produce from 'immer';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { makeSelectWhoami } from 'containers/Auth_old/selectors';

import { SettingSwitch } from '../../../SettingSwitch';
import { messages } from '../messages';

interface AsksHiringGoalProps {
  stage: WorkflowStageDetail;
  setStage: React.Dispatch<React.SetStateAction<WorkflowStageDetail>>;
}

export const AsksHiringGoal: FC<AsksHiringGoalProps> = ({
  stage,
  setStage,
}) => {
  const { feature_flags: featureFlags } = useSelector(makeSelectWhoami());
  const enabled = Boolean(featureFlags?.['staples-multi-hiring-manager']);

  if (!enabled) {
    return null;
  }

  const onToggle = () => {
    setStage(
      produce(stage, draftStage => {
        draftStage.asks_hiring_goal = !draftStage.asks_hiring_goal;
      }),
    );
  };

  return (
    <SettingSwitch
      dataKey="asks_hiring_goal"
      checked={Boolean(stage.asks_hiring_goal)}
      onChange={onToggle}
      label={<FormattedMessage {...messages.asksHiringGoal} />}
      description={<FormattedMessage {...messages.asksHiringGoalDescription} />}
    />
  );
};
